export class Punkt {
    constructor(
            public id: number = null,
            public name: string = null,
            public status: boolean = true) { }
}



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_classes/list/punkt.ts